'use strict';

var _toConsumableArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var base58_chars = require('../private/base58_chars.js');
/**
 * Converts a `base58` string to its corresponding binary representation.
 * @kind function
 * @name base58_to_binary
 * @param {base58_chars} base58String base58 encoded string
 * @returns {Uint8Array} binary representation for the base58 string.
 * @example <caption>Ways to `import`.</caption>
 * ```js
 * import { base58_to_binary } from 'base58-js'
 * ```
 * @example <caption>Ways to `require`.</caption>
 * ```js
 * const { base58_to_binary } = require('base58-js')
 * ```
 * @example <caption>Usage.</caption>
 * ```js
 * const bin = base58_to_binary("6MRy")
 * console.log(bin)
 * ```
 * Logged output will be Uint8Array(3) [15, 239, 64].
 */


var base58_to_binary = function base58_to_binary(base58String) {
  if (!base58String || typeof base58String !== 'string') throw new Error("Expected base58 string but got \u201C".concat(base58String, "\u201D"));
  if (base58String.match(/[0IOl]/gm)) throw new Error("Invalid base58 character \u201C".concat(base58String.match(/[0IOl]/gm), "\u201D"));
  var lz = base58String.match(/^1+/gm);
  var psz = lz ? lz[0].length : 0;
  var size = (base58String.length - psz) * (Math.log(58) / Math.log(256)) + 1 >>> 0;
  return new Uint8Array([].concat(_toConsumableArray(new Uint8Array(psz)), _toConsumableArray(base58String.match(/(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]){1}/gm).map(function (i) {
    return base58_chars.indexOf(i);
  }).reduce(function (acc, i) {
    acc = acc.map(function (j) {
      var x = j * 58 + i;
      i = x >> 8;
      return x;
    });
    return acc;
  }, new Uint8Array(size)).reverse().filter(function (lastValue) {
    return function (value) {
      return lastValue = lastValue || value;
    };
  }(false)))));
};

module.exports = base58_to_binary;